import { IRetrievalQuery } from "@faire/web-api/indigofair/data/IRetrievalQuery";

import { useCategoryPageQuery } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageQuery/useCategoryPageQuery";

export const useCategoryPageAllRetrievalQueries =
  (): Array<IRetrievalQuery> => {
    return useCategoryPageQuery().data?.retrieval_queries ?? [];
  };
